import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { responsive } from "@/lib/media";

const BASE = process.env.REACT_APP_BACKEND_URL;

export function MoreProjects({ currentId }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/gallery").then((r) => setItems(r.data.filter((g) => g.id !== currentId).slice(0, 3))).catch(() => {});
  }, [currentId]);
  if (!items.length) return null;
  return (
    <section className="mt-16" data-testid="more-projects">
      <div className="flex items-end justify-between gap-4 mb-5">
        <h2 className="text-base md:text-lg font-semibold font-display">More installs by David</h2>
        <Link to="/gallery" className="dg-link text-sm">Open gallery →</Link>
      </div>
      <div className="grid gap-4 sm:grid-cols-3">
        {items.map((g) => (
          <Link key={g.id} to={`/project/${g.id}`} className="dg-card rounded-xl overflow-hidden group" data-testid={`more-project-${g.id}`}>
            <div className="h-40 overflow-hidden"><img {...responsive(`${BASE}${g.img}`, "(max-width: 640px) 100vw, 33vw")} alt={g.title} loading="lazy" decoding="async" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" /></div>
            <div className="p-4">
              <span className="dg-chip">{g.category}</span>
              <div className="mt-2 text-sm font-semibold text-slate-100">{g.title}</div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
